/* import combi from "../../../Assets/Images/questions/questionTwo/combi.svg";
import system from "../../../Assets/Images/questions/questionTwo/system.svg";
import regular from "../../../Assets/Images/questions/questionTwo/regular.svg"; */

export const boilerTypeData = [
  {
    title: "Combi",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642169243/AquaHeat/Quote%20Icons/question%202/combi_tl9i4s.svg",
  },
  {
    title: "Standard",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642169243/AquaHeat/Quote%20Icons/question%202/regular_oe9eg2.svg",
  },
  {
    title: "System",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642169243/AquaHeat/Quote%20Icons/question%202/system_qpjlrf.svg",
  },
];
